<template>
  <div style="width: 100%; display: flex; background-color: white; padding: 5%">
    <div style="width: 100%; max-width: 1500px; margin: 0 auto; display: flex;">
      <div
        id="description"
        class="white-section"
        style="flex: 2; position: relative;"
      >
        <div id="inner-services" class="inner-services">
          <div class="section-title" >Our Products and Services</div>
          <div class="section-paragraph">
            <b style="font-size: 1.3rem;">Be blown away by the depth and breadth of our products, services and tools, which can be packaged for you to suit your needs</b> <br/><br/>
            We provide a range of proprietary, customised or real-time products and services including access to our real-time dashboard with mix and match options that can be customised to suit your needs and budget, and a range of decision-support tools.<br/><br/>
            We can also conduct analysis to differentiate natural and unnatural epidemics on request  and conduct pandemic preparedness exercises in virtual, hybrid and face to face mode. Please contact us for more details.
          </div>
          <br/>
          <div class="section-title" >Contact Us</div>
          <div class="section-paragraph">To find out more about EPIWATCH, contact us on the email below and our team will be in touch.</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: 'Services',
  components: {
  },
  data: () => ({
      mobile: null,
      windowWidth: null
    }),
  created() {
      window.addEventListener('resize', this.checkScreen);
      this.checkScreen()
    },
    mounted() {
      this.checkScreen();
    },
    destroy() {
      window.removeEventListener('resize', this.checkScreen)
    },
    methods: {
      checkScreen() {
        this.windowWidth = window.innerWidth;
        if (this.windowWidth <= 1000) {
          this.mobile = true;
        } else {
          this.mobile = false;
        }

        if (document.getElementById("inner-services")) {
          let innerHeight = document.getElementById("inner-services").clientHeight;
          if (document.getElementById("services-wave")) {
            document.getElementById("services-wave").setAttribute("style", "float: left; height: 100%; height: calc("+innerHeight+ "px + 100px);")
            document.getElementById("services-wave").style.height = "calc(" + innerHeight + "px + 100px)"
          }
          if (document.getElementById("services-right")) {
            document.getElementById("services-right").setAttribute("style", "flex: 3; max-height: calc("+innerHeight+"px + 100px);background-color: gray; position: relative; background-size: cover; background-repeat: no-repeat; background-position: center; height: inherit; background-image: linear-gradient(90deg, rgba(230,232,232,0) 85%, rgba(230,232,232,1) 100%), url('/products/services-2.jpg');")
            document.getElementById("services-right").style.maxHeight = "calc(" + innerHeight + "px + 100px)"
          }
        }
        return;
      }
    }
  
}
</script>

<style>
.v-btn__content {
  width: 100%;
  white-space: normal;
}
</style>